import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "update-expense-modal" }
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Jadwal Keberangkatan", -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "md:flex items-center justify-between gap-4" }
const _hoisted_6 = { class: "text-sm text-grey" }
const _hoisted_7 = { class: "text-xl font-bold mb-4" }
const _hoisted_8 = { class: "text-xl font-bold mb-4" }
const _hoisted_9 = { class: "rounded-xl border-grey-2 p-5 mb-4 overflow-visible" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-12 gap-4 pb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-base font-normal" }, "Terminal"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-base font-normal text-center" }, "Datang"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-base font-normal text-center" }, "Berangkat"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-base font-normal text-center" }, "+Hari"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-base font-normal text-center" }, "Tanggal")
], -1)
const _hoisted_11 = { class: "col-span-4 text-base font-semibold text-grey" }
const _hoisted_12 = { class: "col-span-2" }
const _hoisted_13 = { class: "text-base font-semibold text-center border border-gray-300 rounded py-1" }
const _hoisted_14 = { class: "col-span-2" }
const _hoisted_15 = { class: "text-base font-semibold text-center border border-gray-300 rounded py-1" }
const _hoisted_16 = { class: "col-span-1" }
const _hoisted_17 = { class: "text-base font-semibold text-center border border-gray-300 rounded py-1" }
const _hoisted_18 = { class: "col-span-3" }
const _hoisted_19 = { class: "text-base font-semibold text-center" }
const _hoisted_20 = { class: "flex items-center pt-5" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      class: "change-schedule-modal",
      showHeader: true,
      visible: $setup.showModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.showModal) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '75vw' },
      modal: true,
      contentClass: "wrap-ctn-modal-default"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("i", {
              class: "pi pi-times cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
            })
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Button, {
            class: "btn-back mr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeDialog()))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(`PP ${$props.ritData.ppOrder}`), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(`RIT ${$setup.ritCount} : ${$props.ritData.MsRouteName ?? '-'}`), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString($props.ritData.busName ?? '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataSource, (field) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "grid grid-cols-12 items-center gap-4 py-3 border-top-grey-lighten-5",
                key: field.idType
              }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(field.name ?? '-'), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(field.arrival ?? '-- : --'), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(field.departure ?? '-- : --'), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, "+" + _toDisplayString(field.dayOffset ?? 0), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(field.departureDate ?? '-'), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}